import { SeatmapStoreModel } from '@common/interfaces/servicing-seatmap/seatmap-store-model';
/**
 * CheckinSeatmap model details
 */
export interface ServicingSeatmapStateDetails {}

/**
 * ServicingSeatmap store state
 */
export interface ServicingSeatmapState extends ServicingSeatmapStateDetails {
  model: SeatmapStoreModel | null;
}

/**
 * Name of the ServicingSeatmap Store
 */
export const SERVICING_SEATMAP_STORE_NAME = 'servicingSeatmap';

/**
 * ServicingSeatmap Store Interface
 */
export interface ServicingSeatmapStore {
  /** ServicingSeatmap state */
  [SERVICING_SEATMAP_STORE_NAME]: ServicingSeatmapState;
}
